import Helper from './Helper';

class Video {
  constructor() {
    const videos = Array.prototype.slice.call(document.querySelectorAll('.ns-video'));

    videos.forEach((video) => {
      if (video) {
        bindEvents();
      }
    })


    function bindEvents() {
      const playbutton = Array.prototype.slice.call(document.querySelectorAll('.ns-video__thumbnail'));
      playbutton.forEach(button => {
        button.addEventListener('click', () => {

          const video = button.parentElement;
          const thumbnail = button;
          const iframe = video.querySelector('iframe');

          // youtube
          if (iframe.src.indexOf('youtube') >= 0) {
            iframe.src = iframe.src + '&autoplay=1';
            thumbnail.classList.add('fade-out');
            thumbnail.style.display = 'none';

            // console.log("play youtube video")
            return;
          }
          else {
            // console.log("play vimeo video")
            iframe.contentWindow.postMessage('{"method":"play"}', "*");
            thumbnail.classList.add('fade-out');
            thumbnail.style.display = 'none';

            return;
          }

        });
      });
    }
  }
}

export default Video;
